import { Route } from '@angular/router';
import { authGuard } from '@umss/shared/core';

export const routes: Route[] = [
  // Load shell routes (includes FacilityLayoutComponent with side-nav + all feature routes)
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@umss/corporate/feature-shell').then((m) => m.shellRoutes)
  },

  {
    path: 'auth',
    loadChildren: () =>
      import('@umss/corporate/feature-auth').then((m) => m.routes)
  },

  // Fallback - redirect to root (which will redirect to dashboard via shell routes)
  { path: '**', redirectTo: '' }
];
